

export const getShipmentViewDetailsFormatted = (awbViewData) => {
  const transportFlowSummary = awbViewData?.transportPlanDetailFlowList;

  const getDescription = (eachStatus) => {
    let descriptionValue = "";
    const {
      receivedPieces,
      actualPieces,
      piecesUnit,
      receivedWeight,
      actualWeight,
      weightUnit,
    } = eachStatus;

    descriptionValue = `${receivedPieces || 0}/${actualPieces || 0} ${piecesUnit || 'pcs'} -`;
    descriptionValue = `${descriptionValue} ${receivedWeight || 0}/${actualWeight || 0} ${weightUnit ? weightUnit : 'kg'}`;

    return descriptionValue;
  };

  const getDateTime = (eachStatus) => {
    let flightValue = '';
    const { carrierCode, flightNumber, dateTime } = eachStatus;
    if (carrierCode && flightNumber) {
      flightValue = `${carrierCode}${flightNumber}`;
    }

    return { flightValue, dateTime }
  }


  const getLineCircleStatus = (eachSummary, isCircle) => {
    if (!eachSummary?.transportPlanDetailStatusList) return '';

    const { transportPlanDetailStatusList } = eachSummary;
    const actualPcs = transportPlanDetailStatusList[0]?.actualPieces ?? 0;

    const pcsCounter = transportPlanDetailStatusList.reduce(
      (sum, plan) => sum + (plan?.receivedPieces ?? 0),
      0
    );
    const isReplannedCase = transportPlanDetailStatusList.some(
      plan => plan?.status?.toLowerCase()?.includes('replanned')
    );

    if (actualPcs <= pcsCounter && isReplannedCase) {
      return isCircle ? 'middle-ring' : 'dotted-line';
    } else if (actualPcs <= pcsCounter) {
      return isCircle ? 'outer-ring' : 'solid-line';
    } else {
      return isCircle ? 'inner-ring' : 'dotted-line'
    }
  };

  const getStatusLabel = (eachSummary) => {
    const { status, delayed } = eachSummary || {}
    let resultLabel = status || ''
    let badgeColor = 'green'
    if (delayed && resultLabel) {
      resultLabel = `${resultLabel} - Delayed`
      badgeColor = 'red'
    }

    return { status: resultLabel, badgeColor }
  }


  // let doesDottedLineFound = false;
  // let doesEmptyCircleFound = false;

  return transportFlowSummary?.map((eachSummary, index) => {
    const lineStatus = getLineCircleStatus(transportFlowSummary?.at(index + 1));
    const circleStatus = getLineCircleStatus(eachSummary, true);
    // if (circleStatus === 'inner-ring') {
    //   doesEmptyCircleFound = true
    // }
    // if (lineStatus === 'dotted-line') {
    //   doesDottedLineFound = true;
    // }
    const isLastElement = index + 1 === transportFlowSummary?.length
    return ({
      location: eachSummary?.title,
      cards: eachSummary?.transportPlanDetailStatusList?.map((eachStatus) => ({
        description: getDescription(eachStatus),
        ...(getStatusLabel(eachStatus)),
        ...(getDateTime(eachStatus)),
        isDelayed: eachStatus?.delayed,
      })),
      colorSchemes: {
        // circleStatus: doesEmptyCircleFound ? 'inner-ring' : circleStatus,
        // lineStatus: doesDottedLineFound && !isLastElement ? 'dotted-line' : getLineCircleStatus(transportFlowSummary?.at(index + 1)),
        circleStatus, lineStatus
      },
      isLastElement,
    })
  }
  );
};

export const formatShippingDescription = (shippingData, fullAwbData) => {
  const description = shippingData?.description || fullAwbData?.commodity;
  const product = shippingData?.product || fullAwbData?.product;
  const scc = shippingData?.scc || fullAwbData?.sccCode;

  let shipementTypeInfo = "";
  if (description) {
    shipementTypeInfo = description + " - ";
  }
  if (product) {
    shipementTypeInfo = shipementTypeInfo
      ? `${shipementTypeInfo}${product}`
      : product;
  }
  if (scc) {
    shipementTypeInfo = shipementTypeInfo
      ? `${shipementTypeInfo} - ${scc}`
      : scc;
  }

  return shipementTypeInfo;
};